import {
  Create,
  FormTab,
  TabbedForm,
  TextInput,
  BooleanInput,
  required,
  SelectInput,
  ReferenceInput,
  useGetIdentity,
  TopToolbar,
  ListButton,
} from 'react-admin'
import { useTranslate } from 'ra-core'
import * as React from 'react'
import * as PropTypes from 'prop-types'
import WsCampaignUrlHelp from '../../components/WsCampaignUrlHelp'

const WsCampaignCreateActions = ({ basePath }) => (
  <TopToolbar>
    <ListButton basePath={basePath} />
  </TopToolbar>
)

WsCampaignCreateActions.propTypes = {
  basePath: PropTypes.any,
}

export const WsCampaignsCreate = props => {
  const translate = useTranslate()
  const { loading: identityLoading } = useGetIdentity()
  if (identityLoading) return <>Loading...</>
  return (
    <Create actions={<WsCampaignCreateActions />} {...props}>
      <TabbedForm
        submitOnEnter={false}
        syncWithLocation={false}
        redirect="edit"
      >
        <FormTab label={translate('surveys.campaigns.tab_summary_form')}>
          <ReferenceInput
            label={translate('surveys.resources.campaign')}
            source="campaign_id"
            reference="campaigns"
          >
            <SelectInput optionText="name" fullWidth />
          </ReferenceInput>
          <WsCampaignUrlHelp />
          <TextInput
            source="url_ws"
            label="URL WS"
            validate={required()}
            fullWidth
            multiline
            rows={3}
          />
          <BooleanInput
            source="status"
            defaultValue={false}
            format={value => value === 1}
            parse={value => (value ? 1 : 0)}
          />
        </FormTab>
      </TabbedForm>
    </Create>
  )
}
